// Global theme behaviors are added by feature-specific modules.
const mobileMenu = document.querySelector('[data-mobile-menu]');

if (mobileMenu) {
  const syncMobileMenuState = () => {
    document.documentElement.toggleAttribute('data-menu-open', mobileMenu.open);
  };

  const desktopQuery = window.matchMedia('(min-width: 901px)');

  syncMobileMenuState();

  mobileMenu.addEventListener('toggle', syncMobileMenuState);

  desktopQuery.addEventListener('change', (event) => {
    if (event.matches) {
      mobileMenu.open = false;
      syncMobileMenuState();
    }
  });

  if (desktopQuery.matches) {
    mobileMenu.open = false;
    syncMobileMenuState();
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileMenu.open) {
      mobileMenu.open = false;
      mobileMenu.querySelector('summary')?.focus();
    }
  });
}
